module.exports = __webpack_public_path__ + "static/media/spam_on.b2a6e813.svg";